import { createSlice } from "@reduxjs/toolkit";
import {
  CargoNodeInterface,
  PackageHistoryInterface,
  PackageHistoryWithActionsInterface,
  SearchInvoiceInterface,
  TemperatureAlertsDataInterface,
  TemperatureAlertsInterface,
  UndeliveredPackagesCentralizerInterface,
} from "../interfaces/raports.interface";
import {
  fetchActiveCargoCars,
  fetchCargoCar,
  fetchCargoNode,
  fetchPackageHistory,
  fetchPackageHistoryWithActions,
  fetchSearchInvoice,
  fetchTemperatureAlerts,
  fetchUndeliveredPackagesCentralizer,
} from "../api/raports.api";
import { FleetInterface } from "../interfaces/fleet.interface";
import { ActiveTransportsDataInterface } from "../interfaces/transport.interface";

export const defaultStateRaports: {
  searchInvoice: SearchInvoiceInterface;
  cargoNode: CargoNodeInterface;
  activeCargoCars: FleetInterface;
  selectedActiveTransport: ActiveTransportsDataInterface | null;
  undeliveredPackagesCentralizer: UndeliveredPackagesCentralizerInterface;
  packageHistory: PackageHistoryInterface;
  packageHistoryWithActions: PackageHistoryWithActionsInterface;
  temperatureAlerts: TemperatureAlertsInterface;
  selectedTemperatureAlert: TemperatureAlertsDataInterface | null;
  isSolvingTemperatureAlertModalOpen: boolean;
} = {
  searchInvoice: {
    data: [],
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  cargoNode: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  activeCargoCars: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  selectedActiveTransport: null,
  undeliveredPackagesCentralizer: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  packageHistory: {
    data: [],
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  packageHistoryWithActions: {
    data: [],
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  temperatureAlerts: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  selectedTemperatureAlert: null,
  isSolvingTemperatureAlertModalOpen: false,
};

const raports = createSlice({
  name: "raports",
  initialState: defaultStateRaports,
  reducers: {
    clearCargoNode: (state) => {
      return {
        ...state,
        cargoNode: {
          ...defaultStateRaports.cargoNode,
        },
      };
    },
    setSelectedActiveTransport: (
      state,
      action: {
        payload: ActiveTransportsDataInterface | null;
      },
    ) => {
      return {
        ...state,
        selectedActiveTransport: action.payload,
      };
    },
    clearPackageHistory: (state) => {
      return {
        ...state,
        packageHistory: defaultStateRaports.packageHistory,
      };
    },
    clearPackageHistoryWithActions: (state) => {
      return {
        ...state,
        packageHistoryWithActions:
          defaultStateRaports.packageHistoryWithActions,
      };
    },
    setSelectedTemperatureAlert: (
      state,
      action: {
        payload: TemperatureAlertsDataInterface | null;
      },
    ) => {
      return {
        ...state,
        selectedTemperatureAlert: action.payload,
      };
    },
    openSolvingTemperatureAlertModal: (state) => {
      state.isSolvingTemperatureAlertModalOpen = true;
    },
    closeSolvingTemperatureAlertModal: (state) => {
      state.isSolvingTemperatureAlertModalOpen = false;
    },
  },
  extraReducers: (builder) => {
    // fetchSearchInvoice  raport start
    builder.addCase(fetchSearchInvoice.pending, (state) => {
      return {
        ...state,
        searchInvoice: {
          ...defaultStateRaports.searchInvoice,
          isLoading: true,
        },
      };
    });
    builder.addCase(fetchSearchInvoice.rejected, (state, action: any) => {
      return {
        ...state,
        searchInvoice: {
          ...state.searchInvoice,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(fetchSearchInvoice.fulfilled, (state, action) => {
      return {
        ...state,
        searchInvoice: {
          ...state.searchInvoice,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // fetchSearchInvoice  raport end

    // fetch cargo node start
    builder.addCase(fetchCargoNode.pending, (state) => {
      return {
        ...state,
        cargoNode: {
          ...defaultStateRaports.cargoNode,
          isLoading: true,
        },
      };
    });
    builder.addCase(fetchCargoNode.rejected, (state, action: any) => {
      return {
        ...state,
        cargoNode: {
          ...state.cargoNode,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(fetchCargoNode.fulfilled, (state, action) => {
      return {
        ...state,
        cargoNode: {
          ...state.cargoNode,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // fetch cargo node end

    // fetch cargo car start
    builder.addCase(fetchCargoCar.pending, (state) => {
      return {
        ...state,
        cargoNode: {
          ...defaultStateRaports.cargoNode,
          isLoading: true,
        },
      };
    });
    builder.addCase(fetchCargoCar.rejected, (state, action: any) => {
      return {
        ...state,
        cargoNode: {
          ...state.cargoNode,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(fetchCargoCar.fulfilled, (state, action) => {
      return {
        ...state,
        cargoNode: {
          ...state.cargoNode,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // fetch cargo car end

    // fetch active cargo start
    builder.addCase(fetchActiveCargoCars.pending, (state) => {
      return {
        ...state,
        activeCargoCars: {
          ...defaultStateRaports.activeCargoCars,
          isLoading: true,
        },
      };
    });
    builder.addCase(fetchActiveCargoCars.rejected, (state, action: any) => {
      return {
        ...state,
        activeCargoCars: {
          ...state.activeCargoCars,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(fetchActiveCargoCars.fulfilled, (state, action) => {
      return {
        ...state,
        activeCargoCars: {
          ...state.activeCargoCars,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // fetch active cargo end

    // fetch undelivered packages centralizer start
    builder.addCase(fetchUndeliveredPackagesCentralizer.pending, (state) => {
      return {
        ...state,
        undeliveredPackagesCentralizer: {
          ...defaultStateRaports.undeliveredPackagesCentralizer,
          isLoading: true,
        },
      };
    });
    builder.addCase(
      fetchUndeliveredPackagesCentralizer.rejected,
      (state, action: any) => {
        return {
          ...state,
          undeliveredPackagesCentralizer: {
            ...state.undeliveredPackagesCentralizer,
            isLoading: false,
            errorMessage: action.payload.message,
            isError: true,
          },
        };
      },
    );
    builder.addCase(
      fetchUndeliveredPackagesCentralizer.fulfilled,
      (state, action) => {
        return {
          ...state,
          undeliveredPackagesCentralizer: {
            ...state.undeliveredPackagesCentralizer,
            isLoading: false,
            data: action.payload,
          },
        };
      },
    );
    // fetch undelivered packages centralizer end

    // fetchPackageHistory  raport start
    builder.addCase(fetchPackageHistory.pending, (state) => {
      return {
        ...state,
        packageHistory: {
          ...defaultStateRaports.packageHistory,
          isLoading: true,
        },
      };
    });
    builder.addCase(fetchPackageHistory.rejected, (state, action: any) => {
      return {
        ...state,
        packageHistory: {
          ...state.packageHistory,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(fetchPackageHistory.fulfilled, (state, action) => {
      return {
        ...state,
        packageHistory: {
          ...state.packageHistory,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // fetchPackageHistory  raport end

    // fetchPackageHistoryWithActions  raport start
    builder.addCase(fetchPackageHistoryWithActions.pending, (state) => {
      return {
        ...state,
        packageHistoryWithActions: {
          ...defaultStateRaports.packageHistoryWithActions,
          isLoading: true,
        },
      };
    });
    builder.addCase(
      fetchPackageHistoryWithActions.rejected,
      (state, action: any) => {
        return {
          ...state,
          packageHistoryWithActions: {
            ...state.packageHistoryWithActions,
            isLoading: false,
            errorMessage: action.payload.message,
            isError: true,
          },
        };
      },
    );
    builder.addCase(
      fetchPackageHistoryWithActions.fulfilled,
      (state, action) => {
        return {
          ...state,
          packageHistoryWithActions: {
            ...state.packageHistoryWithActions,
            isLoading: false,
            data: action.payload,
          },
        };
      },
    );
    // fetchPackageHistoryWithActions  raport end

    // fetch temperature alerts start
    builder.addCase(fetchTemperatureAlerts.pending, (state) => {
      return {
        ...state,
        temperatureAlerts: {
          ...defaultStateRaports.temperatureAlerts,
          isLoading: true,
        },
      };
    });
    builder.addCase(fetchTemperatureAlerts.rejected, (state, action: any) => {
      return {
        ...state,
        temperatureAlerts: {
          ...state.temperatureAlerts,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(fetchTemperatureAlerts.fulfilled, (state, action) => {
      return {
        ...state,
        temperatureAlerts: {
          ...state.temperatureAlerts,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // fetch temperature alerts end
  },
});

export const {
  clearCargoNode,
  setSelectedActiveTransport,
  clearPackageHistory,
  clearPackageHistoryWithActions,
  setSelectedTemperatureAlert,
  openSolvingTemperatureAlertModal,
  closeSolvingTemperatureAlertModal,
} = raports.actions;

export default raports.reducer;
